var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "base-trun-page",
      attrs: {
        title: "选中记录配置",
        visible: _vm.baseTrunDrawer,
        modal: false,
        "append-to-body": true,
        wrapperClosable: false,
        direction: "rtl"
      },
      on: {
        "update:visible": function($event) {
          _vm.baseTrunDrawer = $event
        }
      }
    },
    [
      _c("MesTable", {
        staticStyle: { height: "93vh" },
        attrs: { data: _vm.records, isColumn: false, toolbar: false },
        scopedSlots: _vm._u([
          {
            key: "MesColumn",
            fn: function() {
              return [
                _vm.mainKeys.length > 0
                  ? _c("vxe-table-column", {
                      attrs: { type: "seq", title: "序号", width: "80" }
                    })
                  : _vm._e(),
                _vm._l(_vm.mainKeys, function(item, index) {
                  return _c("MesColumn", {
                    key: index,
                    attrs: {
                      sortable: "",
                      field: item.field,
                      title: item.title,
                      "min-width": item.width
                    }
                  })
                })
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }